<template>
  <div>
    <div class="choose-good">
      <div class="row-title" v-if="title">{{title}}</div>

      <div class="row-body">
        <goodsItem1 :goodsList="content"></goodsItem1>
      </div>
    </div>
  </div>
</template>

<script>
import goodsItem1 from "@/components/index/GoodsItem1.vue";

export default {
  name: "GoodsList1",
  components: {
    goodsItem1
  },
  props: {
    content: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ""
    }
  },

  data: function() {
    return {};
  },

  methods: {
    goGoodsDetail(url, id) {
      rbLink({
        name: url.substring(0, 1).toUpperCase() + url.substring(1),
        query: {
          id: id
        }
      });
    }
  },

  filters: {}
};
</script>

<style scoped>
.choose-good {
  background: #fff;
  margin-top: 5px;
  clear: both;
}

.row-title {
  padding: 10px 15px;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// GoodsList1.vue?43e5e423